import { createFileRoute } from "@tanstack/react-router";
import HmsaInsurance, { config } from "@/pages/HmsaInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/hmsa-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "HMSA TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn how HMSA policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "HMSA TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn how HMSA policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/hmsa-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/hmsa-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HmsaInsurance />;
}
